export default __webpack_public_path__ + "static/media/MongooseConnection.4d3caeed.PNG";